import ResourcePage from "@/components/ResourcePage";

const STATUS = [
  { value: "draft", label: "Entwurf" },
  { value: "sent", label: "Versendet" },
  { value: "accepted", label: "Angenommen" },
  { value: "rejected", label: "Abgelehnt" },
];

export default function QuotesPage() {
  return (
    <ResourcePage
      resource="quotes"
      title="Angebote"
      subtitle="Angebote zu Firmen, Personen und Leads."
      singular="Angebot"
      newButtonLabel="Angebot erstellen"
      createDialogTitle="Angebot erstellen"
      editDialogTitle="Angebot bearbeiten"
      submitButtonLabel="Angebot speichern"
      emptyDescription="Lege dein erstes Angebot an."
      emptyCreateButtonLabel="Angebot erstellen"
      testidPrefix="quotes"
      defaultValues={{ status: "draft", currency: "EUR" }}
      fields={[
        { name: "quote_number", label: "Angebotsnr.", type: "text", required: true, placeholder: "z. B. ANG-2026-001" },
        { name: "title", label: "Titel", type: "text", required: true },
        { name: "status", label: "Status", type: "select", options: STATUS },
        { name: "amount", label: "Betrag", type: "number", step: "0.01" },
        { name: "currency", label: "Währung", type: "text" },
        { name: "valid_until", label: "Gültig bis", type: "date" },
        {
          name: "company_id",
          label: "Firma",
          type: "select",
          optionsFromResource: "companies",
        },
        {
          name: "contact_id",
          label: "Person",
          type: "select",
          optionsFromResource: "contacts",
          optionLabel: (c) => `${c.first_name} ${c.last_name}`,
        },
        {
          name: "lead_id",
          label: "Lead",
          type: "select",
          optionsFromResource: "leads",
          optionLabel: (l) => l.title,
        },
        { name: "notes", label: "Notizen", type: "textarea", fullWidth: true },
      ]}
      columns={[
        { key: "quote_number", label: "Nr.", render: (r) => <span className="font-mono text-xs">{r.quote_number}</span> },
        { key: "title", label: "Titel", render: (r) => <span className="font-medium text-gray-900">{r.title}</span> },
        { key: "status", label: "Status", badge: true },
        {
          key: "amount",
          label: "Betrag",
          render: (r) =>
            r.amount
              ? new Intl.NumberFormat("de-DE", { style: "currency", currency: r.currency || "EUR" }).format(Number(r.amount))
              : <span className="text-gray-400">—</span>,
        },
        {
          key: "valid_until",
          label: "Gültig bis",
          render: (r) => (r.valid_until ? new Date(r.valid_until).toLocaleDateString("de-DE") : <span className="text-gray-400">—</span>),
        },
      ]}
    />
  );
}
